<template>
  <div class="navcontent">
    <div
      :class="navShow ? 'open' : 'close'"
      style="align-self:center"
      ref="open"
      @click="spread"
    >
      <img class="spread" src="~images/dic.png" />
    </div>
    <transition name="el-fade-in-linear">
      <div class="navCase" v-show="navShow">
        <img class="left-top corner" src="~images/left.png" />
        <img class="left-bottom corner" src="~images/corner.png" />
        <img class="right-top corner" src="~images/top-right.png" />
        <img class="right-bottom corner" src="~images/bot-right.png" />
        <slot name="nav"></slot>
      </div>
    </transition>
    <div class="left-bar">
      <slot name="leftBar"></slot>
    </div>
    <slot name="topBar"></slot>
    <slot name="rightBar"></slot>
  </div>
</template>

<script>
export default {
  name: "NavBar",
  data() {
    return {
      navShow: true
    };
  },
  methods: {
    spread() {
      this.navShow = !this.navShow;
      if (this.navShow) {
        this.circle = true;
      } else {
        this.circle = false;
      }
    }
  }
};
</script>

<style lang="stylus" scoped>
@import '~styl/largeScreen/NavBar'
@import '~styl/smallScreen/NavBar'
</style>
